module.exports = __webpack_public_path__ + "static/media/mangup.019b9af1.png";